/*
  CR76 round 2: a card size tap opens the side cart instead of leaving the page (owner chose
  option B from the side-by-side preview, 2026-09-21).

  The size row (snippets/nm-card-sizes.liquid) is one form whose submit buttons each carry a
  variant id. Without this script it posts to /cart/add and lands on the cart page -- that stays
  the fallback, so if this file fails to load, or there is no cart drawer on the page, or the add
  is refused, the shopper still gets the item and the cart page.

  With it: the add happens in the background and the theme's own cart drawer is re-rendered and
  opened, the same way Dawn's product-form.js does it from a product page. The drawer's section
  markup already carries the free-shipping progress bar at the top (snippets/cart-drawer.liquid,
  directly under the heading), so the re-render brings the bar with the new total.

  FormData(form) does not include the button that was pressed, so the variant id is read from
  event.submitter.
*/
(function () {
  'use strict';
  // CR76 r4: loaded by the grid sections and by the homepage showcase; run once, or one tap would add twice.
  if (window.__nmCardQuickAdd) return;
  window.__nmCardQuickAdd = true;

  document.addEventListener('submit', function (event) {
    var form = event.target;
    // CR76 r4: the homepage showcase's size row uses data-nm-quickadd (the .nm-sizes class carries card-overlay CSS).
    if (!form.classList || !(form.classList.contains('nm-sizes') || form.hasAttribute('data-nm-quickadd'))) return;

    var drawer = document.querySelector('cart-drawer');
    var button = event.submitter;
    if (!drawer || typeof drawer.renderContents !== 'function' || !button || !button.value || !window.fetch) return;

    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    form.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');

    var body = new FormData(form);
    body.set('id', button.value);
    body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
    body.append('sections_url', window.location.pathname);

    var url = (window.routes && window.routes.cart_add_url) || form.getAttribute('action');
    fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message || 'add refused');
        // The drawer element carries `is-empty` while the cart is empty, and that class hides the
        // heading and the item list. renderContents() only clears it on the inner wrapper, so Dawn's
        // product-form.js removes it from the drawer itself first -- this does the same. Without it
        // the first add into an empty cart opened a drawer with a total but no heading or item row.
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
        // Let the rest of the theme (cart bubble, cart-page listeners) know the cart changed.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nm-card-quickadd', productVariantId: button.value, cartData: state });
        }
      })
      .catch(function () {
        // Fall back to the plain form post (the cart page), which shows Shopify's own message if
        // the size has just sold out. form.submit() skips this listener and sends no submitter,
        // so the chosen id rides in a hidden field.
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'id'; hidden.value = button.value;
        form.appendChild(hidden);
        form.submit();
      })
      .finally(function () {
        form.removeAttribute('aria-busy');
        button.classList.remove('is-loading');
      });
  });
})();
